import styled from 'styled-components'
import { mildGray } from '../../../../styles/variables.js'

const StepDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1;
  padding: 10px
  padding-bottom: 80px;
  margin-left: 30px;
`

const StepDetailsRow = styled.div`
  display: flex;
  flex-direction: row;

  & > div {
    flex: 1 1;
  }

  & > div:last-child {
    margin-left: 20px;
  }

  & > div:first-child {
    margin-left: 0;
  }
`

const Label = styled.div`
  font-size: 14px;
  color: ${mildGray};
  margin-bottom: 15px;
`

const Placeholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const StepDescriptionBlock = styled.div`
  flex: 1 1;
`

const StepQuantityBlock = styled.div`
  margin-left: 30px;
`

const StepValuesRow = styled.div`
  display: flex;
  flex-direction: row;
  & > div {
    margin-right: 30px;
    min-width: 165px;
    max-width: 165px;
  }
`

const ImageContainer = styled.div`
  margin: 20px 0;
`

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  & > div {
    margin-right: 40px;
  }
  margin-bottom: 20px;
`

const CheckboxLine = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`

export default {
  StepDetails,
  StepDetailsRow,
  Label,
  Placeholder,
  StepDescriptionBlock,
  StepQuantityBlock,
  StepValuesRow,
  ImageContainer,
  CheckboxContainer,
  CheckboxLine,
}
